import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { HoverCard as HoverCardPrimitive, HoverCardTrigger as HoverCardTriggerPrimitive, HoverCardPortal as HoverCardPortalPrimitive, HoverCardContent as HoverCardContentPrimitive, type HoverCardProps as HoverCardPrimitiveProps, type HoverCardTriggerProps as HoverCardTriggerPrimitiveProps, type HoverCardContentProps as HoverCardContentPrimitiveProps } from '@/components/animate-ui/primitives/radix/hover-card';
import { cn } from '@/lib/utils';
type HoverCardProps = HoverCardPrimitiveProps;
function HoverCard(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <HoverCardPrimitive {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
type HoverCardTriggerProps = HoverCardTriggerPrimitiveProps;
function HoverCardTrigger(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <HoverCardTriggerPrimitive {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
type HoverCardContentProps = HoverCardContentPrimitiveProps;
function HoverCardContent(t0) {
  const $ = _c(12);
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      align: t1,
      sideOffset: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const align = t1 === undefined ? "center" : t1;
  const sideOffset = t2 === undefined ? 4 : t2;
  let t3;
  if ($[5] !== className) {
    t3 = cn("bg-popover text-popover-foreground z-50 w-64 origin-(--radix-hover-card-content-transform-origin) rounded-none border p-4 outline-hidden", className);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== align || $[8] !== props || $[9] !== sideOffset || $[10] !== t3) {
    t4 = <HoverCardPortalPrimitive><HoverCardContentPrimitive align={align} sideOffset={sideOffset} className={t3} {...props} /></HoverCardPortalPrimitive>;
    $[7] = align;
    $[8] = props;
    $[9] = sideOffset;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
export { HoverCard, HoverCardTrigger, HoverCardContent, type HoverCardProps, type HoverCardTriggerProps, type HoverCardContentProps };